class ProtectedTeamsDatatable {
    constructor(el){
        this.init(el);
    }
    init(el){
        const datatable =  $(el).DataTable({
            processing: true,
            serverSide: false,
            stateSave: false,
            info: true,
            paging: true,
            ajax: {
                url: '/security-settings/?do=getProtectedTeams',
                type: 'POST',
            },
            language: {
                emptyTable: "No data found"

            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=protected-teams-datatable_length]').select2({minimumResultsForSearch: -1});
                // Add delay to datatable search
            },
            columns: [
                {
                    data: 'name',
                    title: 'Team',
                    sortable: true,
                    render: function (data, type, row) {
                        let name = row['name'];
                        let letter = name.charAt(0).toUpperCase();
                        return '<div class="d-flex" data-kt-element="team">\n' +
                            '                                                        <!--begin::Logo-->\n' +
                            '                                                        <span class="d-flex flex-center flex-shrink-0 w-40px me-3">\n' +
                            '                                                            <div class="symbol symbol-circle symbol-35px">\n' +
                            '                                                                <div class="symbol-label fw-bold bg-primary text-inverse-primary">'+letter+'</div>\n' +
                            '                                                            </div>\n' +
                            '                                                        </span>\n' +
                            '                                                        <!--end::Logo-->\n' +
                            '                                                        <!--begin::Info-->\n' +
                            '                                                        <span class="d-flex flex-column align-items-start name-product sub-name-product">\n' +
                            '                                                            <a href="'+row['dashboard_link']+'"><span class="fs-5 fw-bold text-primary text-decoration-underline-ga primary mb-1" data-kt-element="title">\n' +
                            '                                                                '+name+'\n' +
                            '                                                            </span></a>\n' +
                            '                                                            <span class="fs-7 fw-bold ga-text-primary-500 lh-sm" data-kt-element="desc">\n' +
                            '                                                                '+row['product']+'\n' +
                            '                                                            </span>\n' +
                            '                                                        </span>\n' +
                            '                                                        <!--end::Info-->\n' +
                            '                                                    </div>';
                    }
                },
                {
                    data: 'role',
                    title: 'Role',
                    className: 'min-w-80px',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<span class="badge badge-light-danger me-1">'+row['role']+'</span>';
                    }
                },

                {
                    data: 'idp',
                    title: 'Identity Provider',
                    className: 'min-w-150px',
                    sortable: true,
                    render: function (data, type, row) {
                        let img = "/media/goodaccess/logo/goodaccess-mobile.svg";
                        if(row['idp']['name'] === 'GoodAccess'){

                            return '<div class="d-flex"><img alt="Logo" src="'+img+'" class="h-25px me-3">'+row['idp']['name']+'</div>';
                        }else{
                            return '<div class="d-flex"><img alt="Logo" src="/vendor/production/avatars/svg/'+row['idp']['icon']+'.svg" class="h-25px me-3">'+row['idp']['name']+'</div>';
                        }
                    }

                },

                {
                    data: 'is_application_mfa_enabled',
                    title: 'MFA Status',
                    className: 'min-w-150px',
                    sortable: true,
                    render: function (data, type, row) {
                        var message = '';

                        let cp_authorization_mark    = '<span class="text-danger">Not Required</span>';
                        let app_authorization_mark   = '<span class="text-danger">Not Required</span>' ;

                        if(row['is_application_mfa_enabled']){
                            app_authorization_mark = '<span class="text-success">Required</span>';
                        }
                        if(row['is_cp_mfa_enabled']){
                            cp_authorization_mark = '<span class="text-success">Required</span>';
                        }
                        return '<div class="d-flex flex-stack">' +
                            '       <div class="d-flex flex-stack flex-row-fluid d-grid gap-2">' +
                            '           <div class="me-5">' +
                            message +
                            '               <span class="fw-semibold d-block fs-7 ga-text-primary-800">Control Panel: <span class="connection_status_datetime">'+cp_authorization_mark+'<span></span>' +
                            '               <span class="fw-semibold d-block fs-7 ga-text-primary-800">Client Application: <span class="connection_status_datetime">'+app_authorization_mark+'<span></span>' +
                            '           </div>\n' +
                            '        </div>\n' +
                            '   </div>';
                    }
                },
                {
                    title: 'Actions',
                    sortable: true,
                    render: function (data, type, row) {

                        let html = '<div class="d-flex" id="'+row['id']+'">';
                        if((row['role'] === 'Owner' || row['role'] === 'Admin') && row['idp']['name'] === 'GoodAccess'){
                            html += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-branch"  data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Manage Team MFA">' +
                                '<a href="'+row['settings_link']+'" class="menu-icon">\n' +
                                '                                                    <i class="fa-solid fa-user-lock"></i>\n' +
                                '                                                </a>'+
                                '</div>';

                                if(!row['is_cp_mfa_enabled'] && !row['is_application_mfa_enabled']){
                                    html += '<i class="ki-duotone ki-information fs-2tx text-danger me-4" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Your team is currently not protected by multi-factor authentication and it is recommended that you enable it for added security."><span class="path1"></span><span class="path2"></span><span class="path3"></span></i>';

                                }else if(!row['is_cp_mfa_enabled'] || !row['is_application_mfa_enabled']){
                                    html += '<i class="ki-duotone ki-information fs-2tx text-warning me-4" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="You currently have only one of our multi-factor authentication options enabled. For enhanced team security, it is recommended to have both options enabled."><span class="path1"></span><span class="path2"></span><span class="path3"></span></i>';

                                }
                        }
                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#protected-teams-datatable').hide();
                $('[data-kt-docs-table-toolbar=base]').addClass('d-none');
                $('#team-overview_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        });
        return datatable;
    }
}
window.ProtectedTeamsDatatable = ProtectedTeamsDatatable;